import React from "react";
import PropTypes from "prop-types";
import { StatusChip } from "../ui/Chip";

const CardsData = ({ data }) => {
  const statusColorMap = {
    OK: {
      color: "success",
      label: "Activo",
    },
    DESCONECTADO: {
      color: "warning",
      label: "Inactivo",
    },
    WARNING: {
      color: "warning",
      label: "Pendiente",
    },
    Bound: {
      color: "bound",
      label: "Conectado",
    },
    "": {
      color: "neutral",
      label: "Desconectado",
    },
  };

  return (
    <div className="mt-4 rounded-lg py-2 w-full">
      <div className="grid xs:grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-2">
        {data.map((item, index) => {
          return (
            <div
              key={index}
              className="bg-white px-4 py-2 rounded-lg  !border-green-200 hover:!bg-gray-200 cursor-pointer hover:!border-red-500"
            >
              <div className="flex justify-between gap-2">
                <div className="flex items-center justify-start gap-1">
                  <StatusChip
                    label={statusColorMap[item.vc_conexion]?.label}
                    variant={statusColorMap[item.vc_conexion]?.color}
                  />

                  <StatusChip
                    label={statusColorMap[item.vc_statussmpp.trim()]?.label}
                    variant={statusColorMap[item.vc_statussmpp.trim()]?.color}
                  />
                </div>

                <StatusChip label={item.vc_operadora} variant="info" />
              </div>
              <div className="flex justify-between">
                <div className="tex-md font-semibold my-2">
                  {item.vc_service}
                </div>
                <div className="flex items-center gap-1">
                  <span className="material-symbols-outlined text-primary">
                    call
                  </span>
                  <spa className="font-semibold text-primary">
                    {item.vc_marcacion}
                  </spa>
                </div>
              </div>
              <div className="flex justify-between gap-2">
                <div className="flex items-center border border-default-200 px-2 py-1 rounded-md">
                  <span className="material-symbols-outlined text-sm text-gray-400 mr-2">
                    dns
                  </span>
                  <span className="text-gray-600 font-mono text-xs">
                    {item.vc_ip}
                  </span>
                </div>
                <div className="flex items-center text-gray-400 border border-default-200 px-2 py-1 rounded-md">
                  <span className="material-symbols-outlined text-lg mr-2 text-gray-400">
                    schedule
                  </span>
                  <div className="text-right">
                    <div className="text-xs text-gray-400">
                      Última actualización
                    </div>
                    <div className="text-sm font-medium">
                      {new Date(item.last_update).toLocaleString()}
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="text-sm bg-gray-50 rounded-lg">
                {item.vc_message}
                </div> */}
            </div>
          );
        })}
      </div>
    </div>
  );
};
CardsData.propTypes = {
  data: PropTypes.array,
};
export default CardsData;
